<ng-container>
	<base-display [alignment]="getAlignment()" [smallLetters]="s()" [bigLetters]="b()" [unit]="unit()" [scaleElements]="getScaleElements()" [showScale]="hasScale()" [scaleType]="scaleType()"></base-display>
</ng-container>